import React from "react";
import "./OntarioConfirmDialog.css";

interface Props {
  visible: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export class OntarioConfirmDialog extends React.Component<Props> {

  componentDidMount() {
    if (this.props.visible) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.visible !== prevProps.visible) {
      document.body.style.overflow = this.props.visible ? 'hidden' : '';
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  render() {
    if (!this.props.visible) {
      return null;
    }

    return (
      <div className="ontario-exit-dialog-overlay" onClick={this.props.onCancel}>
        <div className="ontario-exit-dialog" onClick={(e) => e.stopPropagation()}>
          <h4 className="ontario-exit-dialog__heading">
            {this.props.title}
          </h4>
          <p className="ontario-exit-dialog__body">
            {this.props.message}
          </p>
          <div className="ontario-exit-dialog__actions">
            <button
              className="ontario-button ontario-button--secondary"
              onClick={this.props.onConfirm}
            >
              {this.props.confirmLabel}
            </button>
            <button
              className="ontario-button ontario-button--primary"
              onClick={this.props.onCancel}
            >
              {this.props.cancelLabel}
            </button>
          </div>
        </div>
      </div>
    );
  }
}